import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { service } from '@ember/service';
import { t } from 'ember-intl';
import { on } from '@ember/modifier';
import { macroCondition, isDevelopingApp } from '@embroider/macros';
// eslint-disable-next-line ember/no-at-ember-render-modifiers
import didInsert from '@ember/render-modifiers/modifiers/did-insert';
import {
  HdsModal,
  HdsTextBody,
  HdsCardContainer,
  HdsTextDisplay,
  HdsButtonSet,
  HdsButton,
  HdsLinkStandalone,
} from '@hashicorp/design-system-components/components';
import { Flex } from 'core/components';
import { boxPadding } from 'core/modifiers';

export default class TfcMigrationModal extends Component {
  @service api;
  @service currentUser;
  @tracked showModal = false;

  checkForMigration = async () => {
    try {
      const { notification } =
        await this.api.tfcSynchronization.notificationsServiceGetNotification();
      this.showModal = !notification?.acknowledgedAt;
    } catch {
      return;
    }
  };

  close = () => {
    this.showModal = false;
  };

  acknowledge = async () => {
    try {
      await this.api.tfcSynchronization.notificationsServiceAcknowledgeNotification();
    } catch (e) {
      if (macroCondition(isDevelopingApp())) {
        console.error(e);
      }
    } finally {
      this.close();
    }
  };
  <template>
    <div {{didInsert this.checkForMigration}}>
      {{#if this.showModal}}
        <HdsModal
          class="tfc-migration-modal"
          @onClose={{this.acknowledge}}
          @size="large"
          @isDismissDisabled={{false}}
          data-test-tfc-migration-modal
          as |M|
        >
          <M.Header @tagline={{t "components.tfc-migration-modal.tagline"}}>
            {{t "components.tfc-migration-modal.title"}}
          </M.Header>
          <M.Body>
            <HdsTextBody @tag="p" @size="200">
              {{t
                "components.tfc-migration-modal.details"
                userEmail=this.currentUser.user.email
                htmlSafe=true
              }}
            </HdsTextBody>
            <HdsCardContainer
              class="tfc-migration-modal__image"
              @level="base"
              @hasBorder={{false}}
            />
            <HdsTextDisplay @size="200" @tag="p" {{boxPadding "2lg 0 md 0"}}>
              {{t "components.tfc-migration-modal.description.title"}}
            </HdsTextDisplay>
            <Flex
              @direction="row"
              @gap="md"
              @alignItems="stretch"
              @justifyContent="space-between"
            >
              <HdsCardContainer
                class="tfc-migration-modal__card"
                @level="base"
                @hasBorder={{false}}
                {{boxPadding "lg"}}
              >
                <HdsTextBody
                  @tag="p"
                  @size="100"
                  @weight="semibold"
                  {{boxPadding "0 0 sm 0"}}
                >{{t
                    "components.tfc-migration-modal.description.account-credentials.header"
                  }}</HdsTextBody>
                <HdsTextBody @tag="p" @size="100">
                  {{t
                    "components.tfc-migration-modal.description.account-credentials.body"
                  }}
                </HdsTextBody>
              </HdsCardContainer>
              <HdsCardContainer
                class="tfc-migration-modal__card"
                @level="base"
                @hasBorder={{false}}
                {{boxPadding "lg"}}
              >
                <HdsTextBody
                  @tag="p"
                  @size="100"
                  @weight="semibold"
                  {{boxPadding "0 0 sm 0"}}
                >
                  {{t
                    "components.tfc-migration-modal.description.everything-else.header"
                  }}
                </HdsTextBody>
                <HdsTextBody @tag="p" @size="100">
                  {{t
                    "components.tfc-migration-modal.description.everything-else.body"
                  }}
                </HdsTextBody>
              </HdsCardContainer>
            </Flex>
          </M.Body>
          <M.Footer>
            <HdsButtonSet>
              <HdsButton
                @text={{t "components.tfc-migration-modal.close"}}
                data-test-acknowledge
                {{on "click" this.acknowledge}}
              />
              {{! TODO: update link once provided from Education team
          https://hashicorp.atlassian.net/browse/HCPIE-2372}}
              <HdsLinkStandalone
                @color="secondary"
                @href="_blank"
                @icon="docs-link"
                @iconPosition="trailing"
                @text={{t "components.tfc-migration-modal.learn-more"}}
                data-test-learn-more
              />
            </HdsButtonSet>
          </M.Footer>
        </HdsModal>
      {{/if}}
    </div>
  </template>
}
